import { Input } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { SearchIcon } from '@/ui/icons/search'
import type { Filters } from './desktop-full-catalog'
import { DEFAULT_CATEGORY_INDEX } from './helpers/constants'

interface StoreSearchProps {
  search: Filters['search']
  onChangeFilters: (filters: Filters) => void
}
export const StoreSearch = ({ search, onChangeFilters }: StoreSearchProps) => {
  const { t } = useTranslation()

  const ecommerceGroup = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_group
  )

  const onSearch = (search: string) => {
    if (search.length === 0) {
      onClear()
      return
    }

    onChangeFilters({ search, categoryIndex: null })
  }

  const onClear = () => {
    onChangeFilters({ search: '', categoryIndex: DEFAULT_CATEGORY_INDEX })
  }

  const isMisako = ecommerceGroup === 'misako'
  const isHoff = ecommerceGroup === 'hoff'

  if (isHoff) {
    return (
      <div className="w-full max-w-60">
        <Input
          type="search"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={t('full_catalog.search')}
          aria-label={t('full_catalog.search')}
          variant="underlined"
          isClearable
          onClear={onClear}
          startContent={
            <SearchIcon width={18} height={18} className="text-neutral-600" />
          }
          classNames={{
            input: ''
          }}
        />
      </div>
    )
  }

  if (isMisako) {
    return (
      <div className="w-full max-w-60">
        <Input
          type="search"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={t('full_catalog.search')}
          aria-label={t('full_catalog.search')}
          variant="underlined"
          isClearable
          onClear={onClear}
          classNames={{
            input: 'placeholder:uppercase'
          }}
        />
      </div>
    )
  }

  return (
    <div className="w-full flex-1 shrink-0 transition-all focus-within:max-w-96 md:max-w-72 [&:has(input:not(:placeholder-shown))]:max-w-96">
      <Input
        type="search"
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={t('full_catalog.search') + '...'}
        aria-label={t('full_catalog.search')}
        variant="bordered"
        isClearable
        onClear={onClear}
        startContent={
          <SearchIcon
            width={18}
            height={18}
            className="pointer-events-none shrink-0 text-neutral-400"
          />
        }
        classNames={{
          inputWrapper: 'border-solid bg-white rounded-lg md:rounded-lgx',
          input: 'placeholder:text-neutral-500'
        }}
      />
    </div>
  )
}
